import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { AuthWrapped } from '~/modules/navigation/components'
import { ServicePointsPage, ServicePointDetailsPage } from '~/modules/servicepoints/view'
import { PATH } from '~/AppRoutes'

export const ServicePointRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('PARCEL_SHOPS')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={ServicePointsPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.DETAILS}/:id`}
        element={<AuthWrapped component={ServicePointDetailsPage} canAccess={canAccess} />}
      />
    </Routes>
  )
}

export const servicePointLinks = {
  servicePointsLink: () => PATH.OVERVIEW,
  servicePointDetailsLink: (id: string) => `/${PATH.DETAILS}/${id}`,
}
